import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

export function HiringSettingsAlerts({ currentUser, locations }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  // editing[locId] = { recipients: string[], inputBuffer: string, savingMsg: string }
  const [editing, setEditing] = useState({});
  const [loadingFor, setLoadingFor] = useState(null);

  async function loadOne(locId) {
    setLoadingFor(locId);
    try {
      const r = await api('GET', `/api/admin/locations/${locId}/alert-email-recipients`, null, headers);
      setEditing(s => ({ ...s, [locId]: {
        recipients: Array.isArray(r.recipients) ? r.recipients : [],
        inputBuffer: '',
        savingMsg: '',
      } }));
    } catch (e) {
      setEditing(s => ({ ...s, [locId]: { recipients: [], inputBuffer: '', savingMsg: `Load failed: ${e.message || e}` } }));
    } finally { setLoadingFor(null); }
  }

  useEffect(() => {
    (locations || []).forEach(l => loadOne(l.id));
  }, [(locations || []).map(l => l.id).join(',')]);

  function update(locId, patch) {
    setEditing(s => ({ ...s, [locId]: { ...(s[locId] || {}), ...patch } }));
  }

  async function save(locId) {
    const cur = editing[locId];
    if (!cur) return;
    update(locId, { savingMsg: 'Saving…' });
    try {
      const r = await api('PUT', `/api/admin/locations/${locId}/alert-email-recipients`,
        { recipients: cur.recipients }, headers);
      update(locId, { recipients: r.recipients || [], savingMsg: 'Saved.' });
      setTimeout(() => update(locId, { savingMsg: '' }), 1800);
    } catch (e) { update(locId, { savingMsg: `Failed: ${e.message || e}` }); }
  }

  function addEmail(locId) {
    const cur = editing[locId];
    if (!cur) return;
    const v = String(cur.inputBuffer || '').trim().toLowerCase();
    if (!v) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      update(locId, { savingMsg: 'Not a valid email.' });
      return;
    }
    if (cur.recipients.includes(v)) {
      update(locId, { inputBuffer: '', savingMsg: 'Already in the list.' });
      return;
    }
    update(locId, { recipients: [...cur.recipients, v], inputBuffer: '', savingMsg: '' });
  }
  function removeEmail(locId, email) {
    const cur = editing[locId];
    if (!cur) return;
    update(locId, { recipients: cur.recipients.filter(e => e !== email), savingMsg: '' });
  }

  return (
    <div className="card" style={{ padding: 16 }}>
      <div className="text-base font-semibold mb-1">Hiring — manager alert routing</div>
      <div className="text-sm text-gray-500 mb-4">
        Who gets emailed when a new application comes in for each café. Empty list
        falls back to <code>barista@empireteaandcoffee.com</code>. Cafe-flexible
        applicants notify all four cafés (deduped). Owner-only.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {(locations || []).map(loc => {
          const cur = editing[loc.id] || { recipients: [], inputBuffer: '', savingMsg: '' };
          return (
            <div key={loc.id} style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 8 }}>
                <div style={{ fontWeight: 600 }}>{loc.name}</div>
                {cur.savingMsg && <div style={{ fontSize: 12, color: cur.savingMsg.startsWith('Failed') ? '#b00020' : '#666' }}>{cur.savingMsg}</div>}
              </div>
              <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {cur.recipients.length === 0 && (
                  <span style={{ fontSize: 12, color: '#888' }}>None — falls back to barista@</span>
                )}
                {cur.recipients.map(e => (
                  <span key={e} style={{ background: '#f0f7f0', border: '1px solid #c8e2c8',
                                          borderRadius: 99, padding: '3px 4px 3px 10px',
                                          display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                    {e}
                    <button onClick={() => removeEmail(loc.id, e)} title="Remove"
                      style={{ background: 'transparent', border: 0, cursor: 'pointer', color: '#666',
                                fontSize: 14, padding: '0 4px', lineHeight: 1 }}>×</button>
                  </span>
                ))}
              </div>
              <div style={{ marginTop: 10, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                <input type="email" value={cur.inputBuffer}
                  onChange={e => update(loc.id, { inputBuffer: e.target.value })}
                  onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addEmail(loc.id); } }}
                  placeholder="add@example.com"
                  style={{ flex: '1 1 200px', minWidth: 0, border: '1px solid #d0d4d9', borderRadius: 6,
                            padding: '6px 10px', fontSize: 13, fontFamily: 'inherit' }} />
                <button onClick={() => addEmail(loc.id)}
                  style={{ border: '1px solid #d0d4d9', borderRadius: 6, padding: '6px 12px',
                            fontSize: 13, background: '#fff', cursor: 'pointer' }}>
                  Add
                </button>
                <button onClick={() => save(loc.id)}
                  style={{ border: 0, borderRadius: 6, padding: '6px 14px', fontSize: 13,
                            background: 'var(--gold)', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
                  Save
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
